import { matchPhase, matchLocation, matchDateLabel } from "./matchDiscovery";
import { explicitRegistrationZone, registrationStart } from "./directorRegistrationModel";

export { matchLocation, matchDateLabel };
export const familyLabel = family => family === "bullseye" ? "Bullseye" : "NRA ARC";
export const directorPath = match => `/matches/manage/${match.family}/${encodeURIComponent(match.matchId)}`;
export const publicPath = match => `/matches/${match.family}/${encodeURIComponent(match.matchId)}`;
export const contactValue = value => ({ name: value?.name || "", email: value?.email || "", phone: value?.phone || "", website: value?.website || "" });
export const blankInformation = () => informationValue(null);
export const informationValue = info => ({ organizerContact: contactValue(info?.organizerContact), description: info?.description || "", timeZone: info?.timeZone || "", schedule: info?.schedule || [], arrivalChecklist: info?.arrivalChecklist || [] });
// Imported device information can omit optional notes or use a different property order.
// Compare only editable values so normalization does not invent unpublished changes.
const comparableInformation = value => {
  const info = informationValue(value);
  const item = row => ({ id: row.id || "", title: row.title || "", note: row.note || "" });
  return { organizerContact: info.organizerContact, description: info.description, timeZone: info.timeZone,
    schedule: info.schedule.map(row => ({ ...item(row), date: row.date || "", time: row.time || "" })),
    arrivalChecklist: info.arrivalChecklist.map(item) };
};
export const sameInformation = (a, b) => JSON.stringify(comparableInformation(a)) === JSON.stringify(comparableInformation(b));
export function directorPhase(match, now = new Date()) {
  const phase = matchPhase(match, now);
  return phase === "in_progress" ? "live" : ["completed", "cancelled"].includes(phase) ? "past" : "upcoming";
}
export function registrationOpen(match) {
  // A saved lifecycle change can arrive before the refreshed registration gate.
  if (match.lifecycle?.cancelledAt || match.publicationState !== "published_public" || match.status !== "scheduled") return false;
  if (match.registrationGate) return Boolean(match.registrationGate.canRegister);
  if (match.registrationSettings?.policyVersion === 1) {
    const settings = match.registrationSettings, now = Date.now();
    const start = registrationStart(match, explicitRegistrationZone(match, {}));
    return match.publicationState === "published_public" && match.status === "scheduled"
      && settings.mode === "open" && (!settings.opensAt || Date.parse(settings.opensAt) <= now)
      && (!settings.closesAt || Date.parse(settings.closesAt) > now) && Boolean(start) && Date.parse(start) > now && directorPhase(match) === "upcoming";
  }
  return match.publicationState === "published_public" && match.status === "scheduled"
    && match.registrationSettings?.mode !== "closed" && directorPhase(match) === "upcoming";
}
export async function loadOwnedPages(loader, userId) {
  const matches = new Map();
  const tokens = new Set();
  let nextToken;
  do {
    const page = await loader(userId, { limit: 100, ...(nextToken ? { nextToken } : {}) });
    for (const match of page.data || []) {
      if (match.ownerUserId === userId && match.matchId) matches.set(match.matchId, match);
    }
    nextToken = page.nextToken || page.meta?.nextToken;
    if (nextToken && (tokens.has(nextToken) || tokens.size >= 199)) throw new Error("The match list did not finish loading. Retry to see all matches.");
    if (nextToken) tokens.add(nextToken);
  } while (nextToken);
  return [...matches.values()];
}
export function sortedDirectorMatches(matches, view) {
  return matches.filter(match => directorPhase(match) === view).sort((a, b) => {
    const left = Date.parse(a.startDate || a.matchDate) || (view === "past" ? 0 : Number.MAX_SAFE_INTEGER);
    const right = Date.parse(b.startDate || b.matchDate) || (view === "past" ? 0 : Number.MAX_SAFE_INTEGER);
    return (view === "past" ? right - left : left - right) || a.matchId.localeCompare(b.matchId);
  });
}
